var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home",class:{ loading: !_vm.loaded }},[_c('v-welcome'),_c('div',{staticClass:"container"},[_c('v-nav'),_c('div',{staticClass:"inner"},[_c('v-about'),_c('v-reviews'),_c('v-contacts')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }